<template>
  <div>
      <indexPage @funBuy="funBuy"></indexPage>
  </div>
</template>

<script>
  import { getDifferentSiteNameInList } from '@/common/js/siteUtil.js'
  const differentSiteList = ['betl', 'b027site', 'b027sport']
  const siteName = getDifferentSiteNameInList(differentSiteList)
  const indexPage = () => import(`@/components/different/${siteName}/index/index.vue`)
  export default {
    name: 'index',
    components: {
      indexPage
    },
    methods: {
      funBuy(data) {
        this.$emit('funBuy', data, 1)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/index/index.vue